import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { S_Card } from '../../../../design/card/card/S_Cards';

export const ResolutionWarningCard = (): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='auth-desktop-warning-card'>
      <S_Card>
        <span>
          {t('acdl_desktop_use_1')}
          <b>{t('acdl_desktop_use_2')}</b>
          {t('acdl_desktop_use_3')}
        </span>
      </S_Card>
    </div>
  );
};
